import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { patch, post } from 'utils/http'

import { useCustomerEnrichApiKey } from './useCustomerEnrichApiKey'
import { useCustomerEnrichApiKeyDelete } from './useCustomerEnrichApiKeyDelete'

export const useCustomerEnrichApiKeyCreate = () => {
  const customerId = Number.parseInt(useCustomerId() ?? '', 10)
  const { data: apiKeys } = useCustomerEnrichApiKey()
  const { deleteEnrichApiKey } = useCustomerEnrichApiKeyDelete()

  const queryClient = useQueryClient()
  const addNotification = useAddNotification()
  const createEnrichApiConfig = async (payload: any) => {
    if (apiKeys) {
      await deleteEnrichApiKey()
    }

    await post('/management/customers/enrich_api', {
      customerId,
      quota: Number.parseInt(payload.quota, 10),
    })

    if (payload.publicApiKeyDomainAllowlist?.length) {
      await patch(`/management/customers/${customerId}/enrich_api`, {
        publicApiKeyDomainAllowlist: payload.publicApiKeyDomainAllowlist,
      })
    }
  }

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: createEnrichApiConfig,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', String(customerId)] })
      addNotification('Enrich API key has been generated')
    },
    onError: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', String(customerId)] })
      addNotification('Error while generating Enrich API key', 'error')
    },
  })

  return {
    createEnrichApiKey: mutateAsync,
    ...rest,
  }
}
